import pattern from 'patterns/emoji';
import { WCCContentEmojiBlock } from '../blocks/emoji/emoji';
import WCCContentPatternRule from './pattern';

const emojione = require('emojione');

export default class WCCContentEmojiRule extends WCCContentPatternRule {
    protected pattern = pattern;

    protected process([shortName]: RegExpExecArray) {
        if (shortName != undefined) {
            const emoji = emojione.emojioneList[shortName];

            if (emoji != undefined)
                return new WCCContentEmojiBlock({ content: shortName, name: shortName });
        }
    }
}